angular.module('b2bLoginApp.directives').directive('statusAction', function(){
    return {
        templateUrl: '/account/status-action.html',
        scope: true,
        link: function(scope) {
            scope.$watch('company.status', function(status, oldStatus, childScope){
                childScope.hidden = true;
                switch (status) {
                    case scope.Status.NOT_PAID:
                    case scope.Status.BANKRUPT:
                    case scope.Status.COLLECTING_AGENCY:
                        childScope.hidden = false;
                        childScope.label = 'title_bar.go_to_billing';
                        break;
                    case scope.Status.BLOCKED_FREE_TRIAL:
                        childScope.hidden = false;
                        childScope.label = 'full-membership-button';
                        break;
                    case scope.Status.NOT_ACTIVE:
                        childScope.hidden = false;
                        childScope.label = 'reactivate-membership-button';
                        break;
                }
            });
        }
    };
});
